export default ({ request }) => ({
  ecomAmzReplenishmentConfirmReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/confirmReplenishment',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailCountApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/count',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailOperateConfirmReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/operate/confirmReplenishment',
      method: 'POST',
      data,
    })
  },
  ecomAmzReplenishmentDetailOperateNoReplenishmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/detail/operate/noReplenishment',
      method: 'POST',
      data,
    })
  },
})
